import { render, staticRenderFns } from "./ShippingHistoryReceivers.html?vue&type=template&id=5926012b&external"
import script from "./ShippingHistoryReceivers.ts?vue&type=script&lang=ts&external"
export * from "./ShippingHistoryReceivers.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingHistoryReceivers.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports